module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('index-main')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d7bc25d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/resetPhonePwd/index.vue
// module id = 1331
// module chunks = 1